/**
 * Bulk Deactivate End Role Interfaces
 */

/**
 * Excel Template Header Item
 */
export interface ExcelHeaderItem {
  value: string;
}

/**
 * API Response for getting Excel template headers
 */
export interface BulkDeactivateHeadersApiResponse {
  data: ExcelHeaderItem[];
}

/**
 * Upload payload for bulk deactivation
 */
export interface BulkDeactivateUploadPayload {
  excel_data: File;
  program_id: number;
}

/**
 * Validation error for rejected records
 */
export interface ValidationError {
  [key: string]: any; // Dynamic fields based on Excel columns
}

/**
 * API Response for bulk deactivation upload
 */
export interface BulkDeactivateUploadApiResponse {
  body: {
    data: {
      messages: string;
      uploaded_count: number;
      deactive_success_users: number;
      validation_errors: ValidationError[];
    };
  };
}

/**
 * Upload response data
 */
export interface BulkDeactivateResponse {
  messages: string;
  uploaded_count: number;
  deactive_success_users: number;
  validation_errors: ValidationError[];
}
